module.exports = __webpack_public_path__ + "static/media/13_potolok_2.71_0.6dd2f709.png";